export default __webpack_public_path__ + "static/media/IMG_0057_3_11zon.1f58bad1.jpg";